import { JsonSerializable } from "@/Common/Models/JsonSerializable";
import { WeightUnit } from "@/Common/Utilities/Units/Units";
import { MedicalItemVitalSign } from "@/Patient/Models/MedicalSummary/MedicalItemVitalSign";
import { GestationalAge } from "@/Patient/Models/ObstetricalFile/GestationalAge";
import { ObstetricalFileVitalSign } from "@/Patient/Models/ObstetricalFile/ObstetricalFileVitalSign";
import { PrenatalVisitInitials } from "@/Patient/Models/ObstetricalFile/PrenatalVisitInitials";

class PrenatalVisit extends JsonSerializable {
    private id: number;
    private vitalSign: ObstetricalFileVitalSign;

    public Date: Date;
    public WeeksOfGestation: GestationalAge;
    public HeightOfUterineFundus: string;
    public VitalSignEmrTemplateId: string;
    public Albuminuria: string;
    public Glycosuria: string;
    public FetalMovement: string;
    public Contractions: string;
    public FetalHeart: string;
    public Presentation: string;
    public Edema: string;
    public Description: string;
    public TreatmentOrRemarks: string;
    public Initials: PrenatalVisitInitials;
    public ContributionId: string;

    constructor(fields?: Partial<PrenatalVisit>) {
        super({ excludedFields: ["id", "vitalSign"] });
        Object.assign(this, fields);
        this.id = sessionStore.newId();
        this.WeeksOfGestation = new GestationalAge(fields?.WeeksOfGestation);
        this.Initials = new PrenatalVisitInitials(fields?.Initials);
    }

    public updateVitalSignValue(updatedVitalSign: MedicalItemVitalSign, unit: WeightUnit): void {
        this.vitalSign.updateValueFromMedicalItemVitalSign(updatedVitalSign, unit);
        this.VitalSignEmrTemplateId = updatedVitalSign?.EMRTemplateId;
    }

    public get VitalSign(): ObstetricalFileVitalSign {
        return this.vitalSign;
    }

    public set VitalSign(vitalSign: ObstetricalFileVitalSign) {
        this.vitalSign = vitalSign;
    }

    public get Id(): number {
        return this.id;
    }

    public get Weight(): number {
        return this.vitalSign?.weight;
    }

    public set Weight(value: number) {
        if (this.vitalSign)
            this.vitalSign.weight = value;
    }

    public set WeightUnit(unit: WeightUnit) {
        if (this.vitalSign)
            this.vitalSign.weightUnit = unit;
    }
}

export { PrenatalVisit };
